export default "__VITE_ASSET__4f453fb5__"